export const AUTH_MESSAGES = {
  AUTHENTICATION_ERROR: "Authentication Error",
  INACTIVE_ACCOUNT: "Your account is inactive. Contact admin.",
  AUTH_FAILED: "Authentication failed. Please try again.",
  INVALID_CALLBACK: "Invalid callback — missing authorization code",
  COMPLETING_SIGNIN: "Completing sign-in…",
  BACK_TO_LOGIN: "Back to Login",
} as const;

export const AUTH_ROUTES = {
  LOGIN: "/login",
  DASHBOARD: "/admin/dashboard",
  CALLBACK: "/auth/callback",
} as const;

export const SSO_LOGIN_TEXT = {
  TITLE: "Sign in",
  DESCRIPTION: "Sign in to access the Catalogue Portal",
  BUTTON_LABEL: "Sign in with SSO",
  SECURE_AUTH_TEXT: "Secure authentication",
  MS_ACCOUNT_REQUIRED: {
    TITLE: "Microsoft Account Required",
    DESCRIPTION:
      "Use your organization's Microsoft account to access the catalogue portal securely.",
  },
} as const;

export function getAuthApiUrl(): string {
  return process.env.NEXT_PUBLIC_AUTH_API_URL?.replace(/\/$/, "") ?? "";
}

export function getFrontendUrl(): string {
  return (
    process.env.NEXT_PUBLIC_FRONTEND_URL?.replace(/\/$/, "") ??
    "http://localhost:3000"
  );
}

export function getMicrosoftLoginUrl(): string {
  const authApi = getAuthApiUrl();
  if (!authApi) {
    throw new Error(
      "NEXT_PUBLIC_AUTH_API_URL is not set. Add it to .env.local and restart the dev server.",
    );
  }

  const redirectUri = `${getFrontendUrl()}${AUTH_ROUTES.CALLBACK}`;
  return `${authApi}/auth/staff/microsoft/login?redirect_uri=${encodeURIComponent(redirectUri)}`;
}
